export default {
  path: '/task',
  meta: {
    title: '任务中心',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/task`),
}



// WEBPACK FOOTER //
// ./src/views/task/router.js